import TicketTemplates from '../../../../store/tickets/templates';

angular
    .module('festzelt-os.modules.tickets.templates')
    .factory('TicketTemplates', [
        '$injector',
        'TicketTemplate',
        ($injector, TicketTemplate) => new TicketTemplates(TicketTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/store/templates.js